/*
 * @Author: xiaowei
 * @Date: 2018-11-29 16:16:04
 * @Last Modified by: xiaowei
 * @Last Modified time: 2019-06-04 10:34:29
 */


class ColorStyle {
  constructor() {
    this.name = 'colorStyle'

  }
  /**
   * 按数值区间生成样式
   * 分段数默认为8
   * @param  {Object}  option 	配色参数 {colorType: 色调类型, isReverse: 倒转色带, piece: 分段数, style: 默认地图样式}
   * @param  {Array}   dataRange  值区间
   * @return {Array}   样式数组
   */
  getStyleByValue(option, dataRange) {
    var e = 'StyleManager按值生成样式';
    // 结果
    var styles = [];
    // 色带长度
    var limitSize = this.getColors(option.colorType).length;
    // 默认地图样式
    var styleOpt = $.extend({
      stroke: false,
      fill: true,
      fillOpacity: '0.92'
    }, option.style);

    // 获取配色方案
    var colors = this.getColors(option.colorType, option.isReverse);
    if (!colors) {
      console.error(e, '配色方案colorType错误:', option.colorType);
      return styles;
    }
    // 分段数
    var piece = option.piece;
    if (!piece || piece + 1 > limitSize) piece = limitSize - 1;
    if (piece < 2) {
      console.error(e, '分段太少:', piece);
      return styles;
    }
    // 计算区间
    var maxValue = Math.max.apply(Math, dataRange);
    var minValue = Math.min.apply(Math, dataRange);
    if (maxValue == minValue) {
      console.warn(e, '值相等');
      if (maxValue >= 0) {
        return [
          [0, 999, {stroke: false,
            fill: true,
            fillColor: '#fff' }]
        ];
      }
      return [
        [-999, 0, {stroke: false,
          fill: true,
          fillColor: '#fff' }]
      ];
    }
    // 或扩大区间
    maxValue = Math.ceil(maxValue);
    minValue = Math.floor(minValue);
    // console.log(minValue, maxValue);

    /**
     * 计算样式
     * @param  {Number}   startValue 开始值
     * @param  {Number}   endValue   结束值
     * @param  {Number}   piece      分段数
     * @param  {Array}   distColors  色带
     * @return {Array}   样式
     */
    function calc(startValue, endValue, piece, distColors) {
      var split = [],
        dist = [],
        diffValue = endValue - startValue,
        pValue = diffValue / piece,
        f = Math.abs(diffValue) < 1 ? 2 : 1, // 计算精度
        i;
      // 分段取值
      for (i = 0; i <= piece; i++) {
        // TODO 浮点运算处理
        split[i] = Number((startValue + pValue * i).toFixed(f));
      }
      //按数轴方向处理：负轴反置
      if (pValue < 0) {
        split.reverse();
        distColors.reverse();
      }
      for (i = 0; i <= piece; i++) {

        var color = $.extend({}, styleOpt, {
          fillColor: distColors.shift()
        });
        dist.push([split[i], split[i + 1], color]);
      }
      // 按数轴方向处理：移除负极值，添加正极值
      if (pValue < 0) dist.pop();
      else dist[piece][1] = 99999;
      //加入结果
      styles = styles.concat(dist);

      return dist;
    }
    // 双色调
    if (option.colorType.length == 2) {
      // 区间位置判断
      var positive = minValue >= 0, //正轴
        negative = maxValue <= 0; //负轴
      if (positive || negative) {
        // 获取对应颜色
        var distColors = this.distColor(colors[Number(positive)], piece + 1);
        calc(minValue, maxValue, piece, distColors);
      } else { //正负轴分段
        // 色调-
        var piece1 = Math.floor(piece / 2), //向正轴偏移
          color1 = this.distColor(colors[0], piece1);
        calc(0, minValue, piece1, color1);
        // 色调+
        var piece2 = piece - piece1,
          color2 = this.distColor(colors[1], piece2 + 1);
        calc(0, maxValue, piece2, color2);
      }
    }
    // 单色调
    else if (option.colorType.length == 1) {
      colors = this.distColor(colors, piece + 1);
      // 计算样式
      calc(minValue, maxValue, piece, colors);
    }

    // console.log(JSON.stringify(styles));
    return styles;
  }

  /**
   * 计算颜色分布
   * @param  {Array}   colors 色带
   * @param  {Number}  size   取色数量
   * @return {Array}          颜色分布
   */
  distColor(colors, size) {
    var colorSize = colors.length;
    var firstColor = colors[0];
    var lastColor = colors[colorSize - 1];
    if (size == 2) { //取两端
      return [firstColor, lastColor];
    } else if (size == 1) { //取首
      return [firstColor];
    } else if (size == 0) {
      return [];
    } else if (size >= colorSize) {
      return colors;
    }

    // 颜色数量
    var distSize = size - 2;
    // 取色间隔
    var distCell = Math.floor((colorSize - 2) / distSize);
    // 结果
    var dist = [firstColor];
    for (var i = 1; i <= distSize; i++) {
      var index = i * distCell;
      var color = colors[index];
      dist.push(color);
    }
    dist.push(lastColor);
    return dist;
  }

  /**
   * 获取配色
   * @author xiaowei
   * @param  {[String]}   type      暖色调(w) | 冷色调 (c)
   * @param  {[Boolean]}  isReverse 是否逆序[false]
   * @return {Array}       配色数组
   */
  getColors(type, isReverse) {
    // 色带
    var color1 = ["#a0f9f4", "#8ce3f6", "#78cdf7", "#64b7f8", "#3c8ae0", "#2874c7", "#145eae", "#004794", "#244ba6"];
    var color2 = ['#fefebe', '#feeaa0', '#fdd283', '#fdb265', '#f88b51', '#ef633e', '#dd3d2d', '#c21c26', '#9d2539'];
    var color3 = ["#3c8ae0", "#64b7f8", "#78cdf7", "#8ce3f6", "#a0f9f4", '#f88b51', '#ef633e', '#dd3d2d', '#c21c26', '#9d2539'];
    //var color3 = ["rgb(255, 20, 0)","rgb(255, 64, 0)","rgb(255, 129, 0)","rgb(255, 255, 0)","rgb(0, 255, 255)","rgb(0, 191, 255)","rgb(0, 129, 255)"]
    if (isReverse) {
      color1.reverse();
      color2.reverse();
      color3.reverse();
    }

    switch (type) {
      case 'c':
        return color1;
      case 'w':
        return color2;
      case 'x':
        return color3;
      case 'wc':
        return [color2, color1];
      case 'cw':
        return [color1, color2];
    }

    return null;
  }

  /**
   * 获取等值线数组
   * @param  {[type]}   styles [description]
   * @return {[type]}          [description]
   */
  getContourValuesByStyle(styles) {
    var contours = [];
    for (var i = 0, len = styles.length; i < len; i++) {
      var contour = styles[i],
        a = contour[0],
        b = contour[1];
      if (Math.abs(a) < 9999) {
        contours.push(a);
      }
      if (Math.abs(b) < 9999) {
        contours.push(b);
      }
    }
    // 去重排序转数组
    //return $.unique(contours).sort(function(a, b) {
    //    return a - b
    //}).join(' ');
    return this.unique(contours).sort(function (a, b) {
      return a - b
    }).join(' ');
  }
  /**
   * 数组去重
   * @param  {Array}   array [description]
   * @return {Array}         [description]
   */
  unique(array) {
    var r = [];
    for (var i = 0, l = array.length; i < l; i++) {
      for (var j = i + 1; j < l; j++)
        if (array[i] === array[j]) j = ++i;
      r.push(array[i]);
    }
    return r;
  }

  /**
   * 根据最大最小值获取部分标准色标
   * @param  {Array}   styles     [description]
   * @param  {Array}   dataRange  值区间
   * @return {Array}              [description]
   */
  getStylesByMinMaxValue(styles, dataRange) {
      // 计算区间
    var maxValue = Math.max.apply(Math, dataRange);
    var minValue = Math.min.apply(Math, dataRange);
    var calculateStyles = [];
    var start;
    var end;
    var isStart = true;
    for (var i = 0, l = styles.length; i < l; i++) {
        var min = styles[i][0];
        var max = styles[i][1];
        if((min > minValue && min < maxValue) || (max < maxValue && max > minValue) ){
            if(isStart){
                isStart = false;
                start = i;
            }
            end = i;
            calculateStyles.push(styles[i]);
        }
    }
    if(calculateStyles.length < 5){
        calculateStyles.splice(0, 0, styles[start - 1]);
        start = start - 1;
        calculateStyles.push(styles[end + 1]);
        end = end + 1;
    }
    if(calculateStyles.length < 5){
        calculateStyles.splice(0, 0, styles[start - 1]);
        calculateStyles.push(styles[end + 1]);
    }

    return calculateStyles;
  }

}


class FeatureUtilityClass {
  getRecordsetFromJson(jsonObject) {
    if (!jsonObject) {
      return;
    }
    var feature = null,
      features = null;
    if (jsonObject.features) {
      features = [];
      for (var i = 0, fe = jsonObject.features, len = fe.length; i < len; i++) {
        feature = this.getFeatureFromJson(fe[i]);
        features.push(feature);
      }
    }
    return new WeatherMap.REST.Recordset({
      datasetName: jsonObject.datasetName,
      fieldCaptions: jsonObject.fieldCaptions,
      fields: jsonObject.fields,
      fieldTypes: jsonObject.fieldTypes,
      features: features
    });
  };

  getFeatureFromJson(jsonObject) {
    var geo = null;
    if (!jsonObject) {
      return;
    }
    geo = jsonObject.geometry;
    if (geo) {
      if (geo.type == "REGION") //解决多边形岛洞问题，其他几何对象创建方法不变
        geo = this.getGeoRegionFromJson(geo);
      else if (geo.type == "POINT")
        geo = WeatherMap.REST.ServerGeometry.fromJson(geo).toGeoPoint();
      else if (geo.type == "LINE")
        geo = WeatherMap.REST.ServerGeometry.fromJson(geo).toGeoLine();
    }

    var names, values, geo,
      attr = {},
      me = this,
      feature;

    names = jsonObject.fieldNames;
    values = jsonObject.fieldValues;
    for (var i in names) {
      attr[names[i]] = values[i];
    }
    feature = new WeatherMap.Feature.Vector(geo, attr);
    if (geo && geo.id) feature.fid = geo.id;
    return feature;
  };

  getGeoRegionFromJson(jsonObject) {
    if (!jsonObject) {
      return;
    }
    var nStart = 0;
    var lines = [];
    for (var p = 0; p < jsonObject.parts.length; p++) {
      var pts = [];
      var ptCount = jsonObject.parts[p];
      for (var i = nStart; i < nStart + ptCount; i++) {
        var pt = new WeatherMap.Geometry.Point(jsonObject.points[i].x, jsonObject.points[i].y);
        pts.push(pt);
      }
      nStart += ptCount;
      var line = new WeatherMap.Geometry.LinearRing(pts);
      lines.push(line);
    }
    return new WeatherMap.Geometry.Polygon(lines);
  };

  /**
   * 插值结果转Feature
   * @param  {[type]}   datas  [description]
   * @param  {[type]}   styles [description]
   * @return {[type]}          [description]
   */
  getIsoRegionFeatures(datas, styles) {
    var result = this.getRecordsetFromJson(datas);
    var features = [];
    var len = result.features.length;
    var minlon = 0;
    var minlat = 0;
    var a = datas.features;
    for (var m = 0; m < a.length; m++) {
      var points = a[m].geometry.points;
      for (var j = 0; j < points.length; j++) {
        if (points[j].x > minlon) minlon = points[j].x;
        if (points[j].y > minlat) minlat = points[j].y;
      }
    }
    for (var i = 0; i < len; i++) {
      var feature = result.features[i];
      var fAttributes = feature.attributes;
      fAttributes['FEATUREID'] = i;
      var fromMinValue = true;
      var value = fAttributes['最小值'];
      if (value == undefined || value == -Infinity) {
        value = fAttributes['最大值'];
        fromMinValue = false;
      }
      // 默认配色 值为0|null
      feature.style = {
        stroke: false,
        fill: true,
        fillColor: '#fff',
        fillOpacity: '0.92'
      };

      //value = fAttributes['dMinZValue']; //如果服务端提取等值线采用setInterval，字段是DMINVALUE；反之，如果是setExpectedZValues，字段是dMinZValue
      if (styles != null) {
        value = Number(value);
        var flag = false;
        for (var j = 0; j < styles.length; j++) {
          var minValue = styles[j][0];
          var maxValue = styles[j][1];
          var style = styles[j][2];
          if ((fromMinValue && value >= minValue && value < maxValue) || //因为value是取下限，所以这里是>=minValue
            (!fromMinValue && value > minValue && value <= maxValue)) { //因为value是取上限，所以这里是<=maxValue
            feature.style = style;
            flag = true;
            break;
          }
        }
        if (!flag) {
          feature.style = styles[0][2];
          console.log('不匹配', value, fAttributes);
        }
      } else console.log('不合法', value, fAttributes);
      features.push(feature);
    }
    return features;
  };


}
export default {
  install(Vue) {
    Vue.prototype.$comsys = new ColorStyle()
    Vue.prototype.$feature = new FeatureUtilityClass()
  }
}



// WEBPACK FOOTER //
// ./src/map/colorStyle.js